import React, { Component, Children } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import qs from 'qs';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import { checkChanges } from '../../utils/checkChanges';
import {
  NEW_SPECIFICATION_PROMPT,
} from '../../constants/promptMessages';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

import List from './List';
import New from './New';
import Edit from './Edit';

class ProjectSpecifications extends Component {
  static propTypes = {
    children: PropTypes.node,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
    }),
    params: PropTypes.shape({
      projectUnitLayoutSpecificationID: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static List = List
  static New = checkChanges(New, { message: NEW_SPECIFICATION_PROMPT })
  static Edit = checkChanges(Edit)

  constructor(props) {
    super(props);
    this.state = {
      token: null,
      loading: true,
      data: null,
    };
  }
  componentDidMount() {
    if (this.props.params.projectUnitLayoutSpecificationID) {
      this.fetchProjectUnitLayoutSpecification();
    } else if (this.props.location.pathname.includes('/new/')) {
      this.fetchProjectUnitLayoutSpecifications();
    } else {
      this.setLoading(false);
    }
  }
  componentWillReceiveProps(nextProps) {
    const { pathname } = nextProps.location;
    if (nextProps.params.projectUnitLayoutSpecificationID) {
      if (pathname !== this.props.location.pathname) {
        this.fetchProjectUnitLayoutSpecification();
      }
    } else if (pathname.includes('/new/')) {
      this.fetchProjectUnitLayoutSpecifications();
    }
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchProjectUnitLayoutSpecification() {
    await this.setLoading(true);
    const { t } = this.props;
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/specifications/unit_layouts/${this.props.params.projectUnitLayoutSpecificationID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const data = await res.json();
      // handle token.. etc
      await this.setComponentState({
        token,
        data,
      });
    }
    await this.setLoading(false);
  }
  async fetchProjectUnitLayoutSpecifications(q = {}) {
    await this.setLoading(true);
    const { t } = this.props;
    const { store } = this.context;
    const query = Object.assign({
      page: 1,
    }, q);
    let res;
    try {
      res = await store.dispatch(fetchM(`/specifications/unit_layouts/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      // handle token.. etc
      await this.setComponentState({
        token,
      });
    }
    await this.setLoading(false);
  }
  renderChild() {
    return Children.map(this.props.children, child => (
      React.cloneElement(child, {
        token: this.state.token,
        loading: this.state.loading,
        data: this.state.data,
        presetID: this.props.params.projectUnitLayoutSpecificationID,
      })
    ));
  }
  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}

const TranslatedProjectSpecifications = withTranslation(namespaces)(ProjectSpecifications);
TranslatedProjectSpecifications.List = ProjectSpecifications.List;
TranslatedProjectSpecifications.New = ProjectSpecifications.New;
TranslatedProjectSpecifications.Edit = ProjectSpecifications.Edit;
export default TranslatedProjectSpecifications;



// WEBPACK FOOTER //
// ./src/containers/ProjectUnitLayoutSpecifications/ProjectUnitLayoutSpecifications.jsx